module.exports = __webpack_public_path__ + "static/media/blowfishy_circle.37ab872d.png";